import ajax from "./request.js";

const href =
  process.env.NODE_ENV === "production"
    ? `https://${window.location.host}/api/cloud/file/thumb/admin`
    : "/api/cloud/file/thumb/admin";

/** umi-request 在部分场景返回 Response，统一解析为 BackResult */
async function readBackResult(promise) {
  const raw = await promise;
  if (raw && typeof raw.json === "function") {
    return raw.json();
  }
  return raw || {};
}

function thumbJobStatus() {
  return readBackResult(ajax(`${href}/status`, { method: "POST", data: {} }));
}

function status() {
  return thumbJobStatus();
}

function setEnabled(enabled) {
  return readBackResult(ajax(`${href}/setEnabled`, { method: "POST", data: { enabled } }));
}

function runNow() {
  return readBackResult(ajax(`${href}/runNow`, { method: "POST", data: {} }));
}

function listThumbRuns(limit = 3) {
  return readBackResult(ajax(`${href}/runs`, { method: "POST", data: { limit } }));
}

function runs(limit = 3) {
  return listThumbRuns(limit);
}

function runItems(runId) {
  return readBackResult(ajax(`${href}/runItems`, { method: "POST", data: { runId } }));
}

function failures() {
  return readBackResult(ajax(`${href}/failures`, { method: "POST", data: {} }));
}

function retryFailures() {
  return readBackResult(ajax(`${href}/retryFailures`, { method: "POST", data: {} }));
}

export default {
  thumbJobStatus,
  status,
  setEnabled,
  runNow,
  listThumbRuns,
  runs,
  runItems,
  failures,
  retryFailures,
};
